import React, { useMemo } from 'react';
import { getOpacity, sankeyLinkHorizontal } from '../../formatters';
import PropTypes from 'prop-types';
import { useNodeAndLinks } from '../../hooks';

const propTypes = {
  link: PropTypes.any,
  sankeyWidth: PropTypes.number,
  sankeyHeight: PropTypes.number,
  colors: PropTypes.func,
  reorganizeGraph: PropTypes.bool,
  columnWidth: PropTypes.number,
}

const Link = ({ colors, link, sankeyWidth, sankeyHeight, reorganizeGraph, columnWidth }) => {
  const { handleMouseEnter, handleMouseMove, handleMouseLeave, opacities, currentActives } = useNodeAndLinks();

  const opacity = useMemo(() => getOpacity(link, currentActives, opacities), [currentActives]);
  const linkSankey = useMemo(() => sankeyLinkHorizontal(), []);
  const strokeLength = 10;

  return (
    <path
      d={linkSankey(link, 5, reorganizeGraph, columnWidth + strokeLength)}
      fill={colors(link, true)}
      fillOpacity={opacity}
      onMouseEnter={event => handleMouseEnter(event, link, sankeyWidth, sankeyHeight)}
      onMouseMove={event => handleMouseMove(event, link, sankeyWidth, sankeyHeight)}
      onMouseLeave={handleMouseLeave}
    />
  );
};

Link.propTypes = propTypes
Link.defaultProps = {}

export default Link;